import * as React from 'react';

const GearChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="gear-chunky_svg__eds-icon--gear-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="gear-chunky_svg__eds-icon--gear-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 14.8c-1.5 0-2.8-1.3-2.8-2.8s1.3-2.8 2.8-2.8 2.8 1.3 2.8 2.8-1.3 2.8-2.8 2.8zm5.9-2c0-.3.1-.5.1-.8 0-.3 0-.5-.1-.8l1.7-1.3c.2-.1.2-.3.1-.5l-1.6-2.8c-.1-.2-.3-.2-.5-.2l-2 .8c-.4-.3-.9-.6-1.4-.8L14 4.3c0-.2-.2-.3-.4-.3h-3.2c-.2 0-.4.1-.4.3l-.3 2.2c-.5.2-.9.4-1.3.7l-2-.8c-.2 0-.4 0-.5.2L4.3 9.4c-.1.2-.1.4.1.5l1.7 1.3c-.1.3-.1.5-.1.8s0 .5.1.8l-1.7 1.3c-.2.1-.2.3-.1.5l1.6 2.8c.1.2.3.2.5.2l2-.8c.4.3.9.6 1.4.8l.3 2.1c0 .2.2.3.4.3h3.2c.2 0 .4-.1.4-.3l.3-2.1c.5-.2.9-.5 1.4-.8l2 .8c.2.1.4 0 .5-.2l1.6-2.8c.1-.2.1-.4-.1-.5l-1.9-1.3z"
        />
    </svg>
);

GearChunkySvg.displayName = 'GearChunkySvg';
export default GearChunkySvg;
